module.exports = __webpack_public_path__ + "img/add-field-icon.e702c61e.svg";